import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

import { cn } from "@/lib/utils";

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(
  ({ className, children, ...props }, ref) => (
    <RadioGroupPrimitive.Root
      ref={ref}
      className={cn("grid gap-2", className)}
      {...props}
    >
      {children}
    </RadioGroupPrimitive.Root>
  )
);
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.RadioGroupItem>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.RadioGroupItem>
>(({ className, children, ...props }, ref) => (
  <label className="flex items-center gap-2">
    <RadioGroupPrimitive.RadioGroupItem
      ref={ref}
      className={cn("shrink-0 size-4 rounded-full bg-white border border-primary data-[state=checked]:border-blue-600 p-[2px]", className)}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex size-full items-center justify-center rounded-full bg-blue-600" />
    </RadioGroupPrimitive.RadioGroupItem>
    <span className="text-detail">{children}</span>
  </label>
))
RadioGroupItem.displayName = RadioGroupPrimitive.RadioGroupItem.displayName;


export { RadioGroup, RadioGroupItem }